import { render, staticRenderFns } from "./PrescriptionGoods.vue?vue&type=template&id=2b9863d9&scoped=true&"
import script from "./PrescriptionGoods.vue?vue&type=script&lang=js&"
export * from "./PrescriptionGoods.vue?vue&type=script&lang=js&"
import style0 from "./PrescriptionGoods.vue?vue&type=style&index=0&id=2b9863d9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b9863d9",
  null
  
)

export default component.exports